import {ValueByDevice} from 'platform/foundation';

import {testIds} from '@dms/routes';
import {TaskCenterCard} from '@dms/task-manager';

import {DashboardTileSize} from '../types/DashboardTileSize';

interface MyTasksProps {
  size: DashboardTileSize;
}

interface MyTasksDensity {
  columns: ValueByDevice<number>;
  naturalNumberOfTasks: ValueByDevice<number>;
  maximumNumberOfTasks: ValueByDevice<number>;
}

// A half tile has the room of two quarters, so it lists the tasks in two row-major columns.
const HALF_DENSITY: MyTasksDensity = {
  columns: [1, 2, 2, 2],
  naturalNumberOfTasks: [4, 10, 12, 12],
  maximumNumberOfTasks: [8, 12, 12, 12],
};

export function MyTasks(props: MyTasksProps) {
  const density = props.size === 'half' ? HALF_DENSITY : undefined;

  return (
    <TaskCenterCard
      isFullHeight
      columns={density?.columns}
      naturalNumberOfTasks={density?.naturalNumberOfTasks}
      maximumNumberOfTasks={density?.maximumNumberOfTasks}
      data-testid={testIds.dashboard.home('tasks')}
    />
  );
}
